"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZipSeasonSlidesState = void 0;
var ZipSeasonSlidesState;
(function (ZipSeasonSlidesState) {
    ZipSeasonSlidesState["GeneratingSeasonSlidesZip"] = "generatingSeasonSlidesZip";
    ZipSeasonSlidesState["DeletingSeasonSlidesZip"] = "deletingSeasonSlidesZip";
})(ZipSeasonSlidesState = exports.ZipSeasonSlidesState || (exports.ZipSeasonSlidesState = {}));
//# sourceMappingURL=zip-season-slides-state.js.map